import React from 'react';

const CBSwitch = ({
  checked,
  onChange, // Function called with the new boolean checked state
  disabled = false,
  className = '',
  // Ant Switch props like checkedChildren/unCheckedChildren are not directly supported
  // Use external labels or visual cues instead
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  // Basic Tailwind toggle switch styling
  const toggleBgClass = checked ? 'bg-indigo-600' : 'bg-gray-200';
  const toggleIndicatorClass = checked ? 'translate-x-5' : 'translate-x-0';

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${toggleBgClass} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={`inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ${toggleIndicatorClass}`}
      />
    </button>
  );
};

export { CBSwitch };